// LanguageContext.tsx
import { createContext, useState, useContext, ReactNode } from "react";

interface AppLanguageContextType {
  appLanguage: string;
  setAppLanguage: (lang: string) => void;
}

const AppLanguageContext = createContext<AppLanguageContextType | null>(null);

export const useAppLanguage = (): AppLanguageContextType | null => useContext(AppLanguageContext);

interface AppLanguageProviderProps {
  children: ReactNode;
}

export const AppLanguageProvider = ({ children }: AppLanguageProviderProps): JSX.Element => {
  const [appLanguage, setAppLanguage] = useState<string>("en");

  return (
    <AppLanguageContext.Provider value={{ appLanguage, setAppLanguage }}>
      {children}
    </AppLanguageContext.Provider>
  );
};
